import { render } from "./CompanyReportPage.vue?vue&type=template&id=4323fd61&ts=true"
import script from "./CompanyReportPage.vue?vue&type=script&lang=ts"
export * from "./CompanyReportPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__